import React, { useEffect } from 'react';
import { useBiLogger } from '../hooks/useBiLogger/useBiLogger';
import { useMetasiteError } from '../context/errors';
import { DsBuilderMethod } from '../types';
import { GeneralError } from '../components/GeneralError/GeneralError';
import { CategoriesRoot } from '../features/categories';
import { useGTM } from '../hooks/useGTM';
import { LocalStorageService } from '../services/storage/LocalStorageService';
import { DS_BUILDER_STORAGE_KEY } from '../types/localStorage';

export type CategoryPageProps = {};

export const Categories: React.FC<CategoryPageProps> = () => {
  const metasiteError = useMetasiteError();
  const biLogger = useBiLogger();
  const { trackFunnelEntry } = useGTM();
  const localStorageService = new LocalStorageService();

  useEffect(() => {
    localStorageService.removeItem(DS_BUILDER_STORAGE_KEY);

    // Existing BI logging
    biLogger.pageView(DsBuilderMethod[DsBuilderMethod.CATEGORY_PAGE]);

    // GTM tracking for funnel entry
    trackFunnelEntry('categories');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (metasiteError) {
    return <GeneralError />;
  }

  return <CategoriesRoot />;
};
